import { render } from "./OpenDestinationList.vue?vue&type=template&id=2cb8858a&scoped=true"
import script from "./OpenDestinationList.vue?vue&type=script&lang=js"
export * from "./OpenDestinationList.vue?vue&type=script&lang=js"

import "./OpenDestinationList.vue?vue&type=style&index=0&id=2cb8858a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb8858a"]])

export default __exports__